import { render, staticRenderFns } from "./other-document.vue?vue&type=template&id=2fe56e24"
import script from "./other-document.vue?vue&type=script&lang=js"
export * from "./other-document.vue?vue&type=script&lang=js"
import style0 from "./other-document.vue?vue&type=style&index=0&id=2fe56e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports